import _property from 'lodash/property';
export var MEDIA_ID_KEY = 'mediaId';
export var SHARED_TO_CUSTOMER_KEY = 'sharedToCustomer';

var contentType = _property('contentType');

var mediaId = _property(MEDIA_ID_KEY);

var type = _property('type');

var name = _property('name');

var url = _property('url');

var id = _property('id');

var objectURL = _property('objectURL');

var userId = _property('userId');

var assetType = _property('assetType');

var publicUrl = _property('publicUrl');

var fileName = _property('originalFileName');

var sharedToCustomer = _property(SHARED_TO_CUSTOMER_KEY);

var mediaSize = _property('mediaSize');

var READER = {
  contentType: contentType,
  mediaId: mediaId,
  name: name,
  type: type,
  url: url,
  id: id,
  objectURL: objectURL,
  userId: userId,
  assetType: assetType,
  publicUrl: publicUrl,
  fileName: fileName,
  sharedToCustomer: sharedToCustomer,
  mediaSize: mediaSize
};
export default READER;